import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export interface BankAccount {
	currency: string;
	iban: string;
	accountNo?: string | null;
	branch: string | null;
	swift: string | null;
}

export interface Bank {
	name: string;
	accounts: BankAccount[];
}

export function useBankAccounts() {
	return useQuery({
		queryKey: ["bank-accounts"],
		queryFn: () => api.get<Bank[]>("/api/bank-accounts"),
		staleTime: 1000 * 60 * 60,
	});
}
